import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import CrudPage from "@/components/CrudPage";
import { StatusBadge } from "@/components/shared";
import AssetTelemetryTab from "@/components/AssetTelemetryTab";
import VehicleCostsTab from "@/components/VehicleCostsTab";
import { fmtDate } from "@/lib/date";

const STATUS_OPTS = ["available", "in_use", "maintenance"];

export default function Vehicles() {
  const [workers, setWorkers] = useState([]);
  useEffect(() => { api.get("/operators").then(({ data }) => setWorkers(data.map((w) => w.name).filter(Boolean))).catch(() => {}); }, []);

  return (
    <CrudPage
      title="Vehicles"
      subtitle="Company fleet — internal vehicles allocated to workers (not charged to clients)"
      endpoint="/vehicles"
      dynamicOptions={{ assigned_worker_name: workers, status: STATUS_OPTS }}
      extraTabs={[
        { key: "telemetry", label: "Telemetry", render: ({ editing }) => <AssetTelemetryTab editing={editing} entityPath="vehicles" /> },
        { key: "costs", label: "Fuel / Costs", render: ({ form, setForm }) => <VehicleCostsTab form={form} setForm={setForm} /> },
      ]}
      columns={[
        { key: "rego", label: "Rego", render: (v) => <span className="font-semibold">{v}</span> },
        { key: "make", label: "Make / Model", render: (v, r) => [r.make, r.model].filter(Boolean).join(" ") || "—" },
        { key: "assigned_worker_name", label: "Assigned Worker", render: (v) => v || <span className="text-gray-400">Unassigned</span> },
        { key: "rego_due_date", label: "Rego Due", render: (v) => fmtDate(v) },
        { key: "service_due_date", label: "Service Due", render: (v) => fmtDate(v) },
        { key: "status", label: "Status", render: (v) => <StatusBadge value={v} /> },
      ]}
      fields={[
        { key: "rego", label: "Rego / Plate", required: true },
        { key: "make", label: "Make" },
        { key: "model", label: "Model" },
        { key: "year", label: "Year" },
        { key: "vin", label: "VIN" },
        { key: "assigned_worker_name", label: "Assigned Worker", type: "select" },
        { key: "status", label: "Status", type: "select", default: "available" },
        { key: "service_due_date", label: "Service Due", type: "date" },
        { key: "rego_due_date", label: "Rego Due", type: "date" },
        { key: "insurance_due_date", label: "Insurance Due", type: "date" },
        { key: "notes", label: "Notes", type: "textarea", full: true },
      ]}
    />
  );
}
